// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__5m9bK","campaignsPage":"style_campaignsPage__gWMFk","academyPage":"style_academyPage__tVIJL"};